import { useCallback } from "react"
import PropTypes from "prop-types"
import { map, some } from "lodash"
import { TableRow, TableCell } from "@mui/material"
import FactorsTableRow from "../factors-table-row"
import NoContributionsRow from "../NoContributionsRow"
import { THRESHOLD_PARAMS } from "helpers/threshold"

function FactorsTableBody({
  data,
  disabled,
  factorTable,
  show,
  allFactors,
  openFactorProfile,
  decompositionTitle,
  drift,
  driftType,
  driftArrows,
  showDriftColumn,
  noPercent,
  noFactorDrilldown,
  thresholdParams,
  formatter,
}) {
  // If any of the following conditions are true, the factor element is not a link
  const isFactorLink = useCallback((i) => !some([
    () => !openFactorProfile,
    () => !factorTable,
    () => !allFactors && i <= 0,
  ], fn => fn()), [allFactors, factorTable, openFactorProfile])

  if (!data.length) {
    return <NoContributionsRow />
  }

  return <>
    {map(data, (contributor, i) => [
      <FactorsTableRow
        key={i}
        {...{
          noPercent,
          drift: drift && drift[contributor.id],
          driftType,
          driftArrow: driftArrows && driftArrows[contributor.id],
          showDriftColumn,
          itemRow: i === 0,
          favorite: contributor.favorite,
          contributor,
          disabled,
          factorLink: isFactorLink(i),
          openFactorProfile,
          show,
          noFactorDrilldown,
          thresholdParams,
          formatter,
        }}
      />,
      contributor.id === "total" && decompositionTitle
        && <TableRow className="detail-row row-subtitle" key="decomposition-subtitle">
          <TableCell component="th" />
          <TableCell component="th" colSpan={2} align="right" title={decompositionTitle}>{decompositionTitle}</TableCell>
        </TableRow>,
    ])}
  </>
}

FactorsTableBody.propTypes = {
  data: PropTypes.array.isRequired,
  openFactorProfile: PropTypes.func,
  disabled: PropTypes.bool,
  factorTable: PropTypes.bool,
  show: PropTypes.func,
  decompositionTitle: PropTypes.string,
  drift: PropTypes.object,
  driftType: PropTypes.string,
  driftArrows: PropTypes.object,
  showDriftColumn: PropTypes.bool,
  noPercent: PropTypes.bool,
  allFactors: PropTypes.bool,
  noFactorDrilldown: PropTypes.bool,
  thresholdParams: THRESHOLD_PARAMS,
  formatter: PropTypes.func,
}

export default FactorsTableBody
